import { AmendmentVisibility } from 'jobs/Job'
import { match } from 'utils/pattern-match-util'

/**
 * Formats the amendment visibility to a string.
 * @param visibility Amendment visibility enum.
 * @returns Visibility as `string`.
 */
export function formatVisibility(visibility: AmendmentVisibility): string {
  return match(visibility, {
    [AmendmentVisibility.Public]: () => 'Public',
    [AmendmentVisibility.Internal]: () => 'Internal',
  })
}
